import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Bushireinyavatpune() {



const cardData =
  {
    keyword: 'Bus Hire in Yavat Pune',
    heading: 'Sanavi Travels: Bus Hire in Yavat Pune',
    headingDescription: 'Sanavi Travels offers professionally managed and highly reliable Bus Hire in Yavat Pune, providing safe, comfortable, and well-organized transportation solutions for families, local residents, corporate teams, schools, wedding guests, picnic groups, and outstation travelers. Yavat, located in Daund taluka of Pune district, is a rapidly developing area with a mix of residential zones, agricultural surroundings, educational institutions, commercial activities, and social venues, leading to frequent demand for dependable group transportation. To meet these varied travel requirements, we offer a wide fleet of AC buses, Non-AC buses, luxury coaches, mini buses, and high-capacity buses suitable for both short-distance local travel and long-distance journeys.',

    top: 'Top Places to Visit Near Yavat Pune with Sanavi Travels',


"topPlaces": [
  {
    "title": "Yavat Town",
    "description": "Yavat is a prominent town in Daund taluka known for its growing residential population, commercial activity, and strong community presence. The town regularly hosts weddings, religious ceremonies, social programs, and local festivals that require organized transportation for large groups. Bus hire services are essential in Yavat to ensure groups travel together comfortably, arrive on time, and avoid coordination issues associated with multiple private vehicles. Renting a bus simplifies logistics while offering a cost-effective and dependable travel solution."
  },
  {
    "title": "Pune–Solapur Highway Access",
    "description": "Yavat is located close to the Pune–Solapur Highway, providing excellent connectivity to Pune city, Daund, Solapur, and surrounding regions. This strategic location makes Yavat a frequent transit point for corporate travel, outstation tours, and long-distance group journeys. Bus rentals along this corridor offer safe, smooth, and comfortable highway travel, especially for large groups."
  },
  {
    "title": "Agricultural Belt Around Yavat",
    "description": "The surrounding areas of Yavat are rich in agricultural land producing sugarcane, grains, and seasonal crops. These rural regions experience regular group travel for farming activities, family visits, community functions, and local festivals. Bus hire services provide reliable transportation across rural roads while maintaining comfort, safety, and schedule discipline."
  },
  {
    "title": "Local Temples and Religious Sites",
    "description": "Several temples and spiritual centers in and around Yavat attract devotees throughout the year, particularly during festivals and special religious occasions. Group travel by bus makes temple visits more organized and economical, allowing families and devotees to travel together comfortably without worrying about parking or route coordination."
  },
  {
    "title": "Weekly Markets and Commercial Areas",
    "description": "Weekly markets and commercial zones in Yavat draw visitors from nearby villages for trade, shopping, and social interaction. Bus hire services are commonly used for collective travel by traders, farmers, and community members, offering convenience and affordability."
  },
  {
    "title": "Wedding Lawns and Event Venues",
    "description": "Marriage halls, banquet spaces, and open wedding lawns around Yavat and Daund depend heavily on bus rentals for guest transportation. Buses help manage large crowds efficiently, reduce traffic and parking challenges, and ensure guests reach venues comfortably and on time."
  },
  {
    "title": "Educational Institutions Nearby",
    "description": "Schools, colleges, and training centers around Yavat frequently organize educational tours, sports competitions, industrial visits, and cultural programs. Bus hire services ensure safe, supervised, and punctual transportation for students and staff, making group travel smooth and well-coordinated."
  },
  {
    "title": "Picnic and Leisure Spots",
    "description": "Open countryside locations, small water bodies, and leisure areas near Yavat are popular destinations for school picnics, family outings, and office get-togethers. Hiring a bus allows groups to enjoy the journey together and return safely without the stress of managing multiple vehicles."
  },
  {
    "title": "Industrial and Business Areas",
    "description": "Small industrial units and commercial establishments near Yavat and along the highway create regular demand for employee transport and business travel. Bus hire services support organized corporate movement and staff transportation efficiently and reliably."
  },
  {
    "title": "Outstation Travel Routes",
    "description": "Yavat offers easy connectivity to Pune, Solapur, Ahmednagar, Shirdi, and other nearby destinations. Bus rentals are ideal for outstation group travel, providing comfortable, safe, and economical transportation for tours, pilgrimages, and extended family trips."
  }
]
,



"services": [
{
"name": "Bus Hire in Yavat Pune",
"description": "Bus Hire in Yavat Pune provides dependable and comfortable buses for families, schools, corporate teams, and social gatherings. This service is ideal for weddings, picnics, school trips, religious journeys, and outstation travel. Our buses are spacious, clean, and well-maintained with comfortable seating, proper ventilation, smooth suspension, and ample luggage space. Professional drivers ensure disciplined driving, punctual pickups, and safe journeys, making group travel organized and stress-free."
},
{
"name": "Bus on Rent Yavat",
"description": "Bus on Rent Yavat offers flexible rental options for both short-distance and long-distance travel. Whether it is a local function, family event, or extended tour, this service ensures reliable transportation with suitable bus options for different group sizes."
},
{
"name": "AC Bus Rental Yavat Pune",
"description": "AC Bus Rental Yavat Pune is ideal for travelers seeking enhanced comfort during summer months and long journeys. Fully air-conditioned interiors, cushioned seating, and reduced travel fatigue make AC buses perfect for weddings, corporate travel, and extended tours."
},
{
"name": "Non AC Bus Hire Yavat",
"description": "Non AC Bus Hire Yavat provides economical and reliable transportation for short routes, rural travel, school trips, and budget-friendly group journeys without compromising safety."
},
{
"name": "Luxury Bus Hire Yavat",
"description": "Luxury Bus Hire Yavat delivers premium travel experiences with modern interiors, stylish seating, and superior comfort. Ideal for weddings, VIP guests, and special events, luxury buses ensure an elegant and memorable journey."
},
{
"name": "Mini Bus Hire Yavat Pune",
"description": "Mini Bus Hire Yavat Pune is suitable for small to medium-sized groups such as family outings, office teams, and local events, offering comfort, flexibility, and economical pricing."
},
{
"name": "32 Seater Bus Hire Yavat",
"description": "32 Seater Bus Hire Yavat is ideal for medium-sized groups including school excursions, corporate outings, and community programs, offering balanced capacity and comfortable travel."
},
{
"name": "35 Seater Bus Rental Yavat",
"description": "35 Seater Bus Rental Yavat supports larger group travel needs such as weddings, religious tours, and long-distance journeys with organized seating and professional drivers."
},
{
"name": "Bus Hire Yavat for Wedding",
"description": "Bus Hire Yavat for Wedding ensures timely and coordinated transportation for wedding guests and family members, simplifying event logistics and reducing travel stress."
},
{
"name": "Bus Hire Yavat for Corporate Travel",
"description": "Bus Hire Yavat for Corporate Travel supports employee movement, meetings, conferences, and team outings with a strong focus on punctuality and professionalism."
},
{
"name": "Bus Hire Yavat for Picnic",
"description": "Bus Hire Yavat for Picnic provides safe and enjoyable transportation for school picnics, family outings, and group leisure trips."
},
{
"name": "Bus Rental Yavat Outstation",
"description": "Bus Rental Yavat Outstation offers dependable long-distance transportation to nearby cities and pilgrimage destinations with passenger comfort as a priority."
},
{
"name": "Bus Hire Yavat with Driver",
"description": "Bus Hire Yavat with Driver provides chauffeur-driven buses where experienced drivers manage routes, traffic, and safety, allowing passengers to relax."
},
{
"name": "Cheap Bus Hire Yavat Pune",
"description": "Cheap Bus Hire Yavat Pune delivers budget-friendly bus hire solutions without compromising on cleanliness, safety, or service reliability."
},
{
"name": "Best Bus Service Yavat",
"description": "Best Bus Service Yavat is known for clean buses, disciplined drivers, transparent pricing, and customer-focused service, making Sanavi Travels a trusted choice."
}
],
"tableData": [
["Bus Hire in Yavat Pune", "Bus on Rent Yavat"],
["AC Bus Rental Yavat", "Non AC Bus Hire Yavat"],
["Luxury Bus Yavat", "Mini Bus Hire Yavat"],
["32 Seater Bus Yavat", "35 Seater Bus Yavat"],
["Wedding Bus Yavat", "Corporate Bus Yavat"],
["Picnic Bus Yavat", "Outstation Bus Yavat"],
["Bus Hire Yavat with Driver", "Cheap Bus Hire Yavat"],
["Best Bus Service Yavat", "—"]
]
,


"whychoose": [
  {
    "WhyChooseheading": "Bus Hire in Yavat Pune with Sanavi Travels",
    "WhyChoosedescription": "Sanavi Travels is a trusted provider of bus hire services in Yavat Pune for families, schools, and corporate groups."
  },
  {
    "WhyChooseheading": "Clean and Comfortable Buses",
    "WhyChoosedescription": "Our buses are regularly maintained to ensure comfort, cleanliness, and a smooth travel experience."
  },
  {
    "WhyChooseheading": "Experienced Local Drivers",
    "WhyChoosedescription": "Drivers are familiar with Yavat, Daund, Pune, and nearby highway routes, ensuring safe and timely journeys."
  },
  {
    "WhyChooseheading": "Transparent Pricing",
    "WhyChoosedescription": "We follow honest pricing policies with no hidden charges."
  },
  {
    "WhyChooseheading": "24/7 Customer Support",
    "WhyChoosedescription": "Our support team is available round the clock to assist with bookings and coordination."
  },
  {
    "WhyChooseheading": "Flexible Rental Options",
    "WhyChoosedescription": "Choose hourly, full-day, multi-day, or customized rental plans as per travel needs."
  },
  {
    "WhyChooseheading": "Safe and Sanitized Vehicles",
    "WhyChoosedescription": "All buses are thoroughly cleaned and sanitized before every trip."
  },
  {
    "WhyChooseheading": "Reliable and On-Time Service",
    "WhyChoosedescription": "We ensure punctual pickups and disciplined operations for stress-free group travel."
  }
]

}

const faqData = [
  {
    question: 'Does Sanavi Travels provide bus hire services in Yavat Pune?',
    answer: 'Yes, Sanavi Travels offers reliable bus hire services in Yavat Pune for all types of group travel.'
  },
  {
    question: 'What types of buses are available in Yavat?',
    answer: 'We provide AC buses, Non AC buses, mini buses, luxury buses, and 32-seater and 35-seater buses.'
  },
  {
    question: 'Is bus hire available for weddings and picnics?',
    answer: 'Yes, we provide dedicated bus services for weddings, picnics, and social events.'
  },
  {
    question: 'Can I book a bus for outstation travel from Yavat?',
    answer: 'Yes, outstation bus rentals are available from Yavat to multiple destinations.'
  },
  {
    question: 'Are the buses sanitized?',
    answer: 'Yes, all buses are cleaned and sanitized before each trip.'
  },
  {
    question: 'Is customer support available during travel?',
    answer: 'Yes, our 24/7 customer support team remains available throughout the journey.'
  }
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Nitin Jadhav',
    feedback: 'We hired a bus from Yavat for a wedding near Daund. The service was very smooth and comfortable.',
    rating: 5
  },
  {
    id: 2,
    name: 'Ms. Ankita Shinde',
    feedback: 'Sanavi Travels arranged a bus for our picnic from Yavat. Clean bus and professional driver.',
    rating: 5
  }
];
















  const Images = [
    { place: "/images/keyword/1.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/2.jpg", text: "Pune to Shirdi Tempo Traveller On Rent", link: "pune-to-shirdi-tempo-traveller-on-rent" },
    { place: "/images/keyword/3.jpg", text: "Pune to Mahabaleshwar Tempo Traveller on Rent", link: "pune-to-mahabaleshwar-tempo-traveller-on-rent" },
    { place: "/images/keyword/4.jpg", text: "Pune to Goa Tempo Traveller Hire", link: "pune-to-goa-tempo-traveller-hire" },
    { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Tempo Traveller on Rent", link: "pune-to-mumbai-tempo-traveller-on-rent" },
    { place: "/images/keyword/6.jpg", text: "Pune to Konkan Darshan Tempo Traveller Hire", link: "pune-to-konkan-darshan-tempo-traveller-hire" },
    { place: "/images/keyword/7.jpg", text: "Pune to Nashik Tempo Traveller On Rent", link: "pune-to-nashik-tempo-traveller-on-rent" },
    { place: "/images/keyword/8.jpg", text: "Tempo Traveller On Rent for Pune Darshan", link: "tempo-traveller-on-rent-for-pune-darshan" },
    { place: "/images/keyword/9.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
    { place: "/images/keyword/10.jpg", text: "13 Seater Tempo Traveller On Rent in Pune", link: "13-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/11.jpg", text: "17 Seater Tempo Traveller on Rent in Pune", link: "17-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/12.jpg", text: "20 Seater Luxury Bus On Rent Pune", link: "20-seater-luxury-bus-on-rent-pune" },
    { place: "/images/keyword/13.jpg", text: "26 Seater Tempo Traveller On Rent in Pune", link: "26-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/14.jpg", text: "32 Seater Luxury Bus On Rent in Pune", link: "32-seater-luxury-bus-on-rent-in-pune" },
    { place: "/images/keyword/15.jpg", text: "35 Seater Bus on Rent in Pune", link: "35-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/16.jpg", text: "45 Seater Bus On Rent in Pune", link: "45-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/17.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/18.jpg", text: "Bus Hire for School Trips in Pune", link: "bus-hire-for-school-trips-in-pune" },
    { place: "/images/keyword/19.jpg", text: "Bus booking for Wedding in Pune", link: "bus-booking-for-wedding-in-pune" },
    { place: "/images/keyword/20.jpg", text: "Bus Booking for Marriage in Pune", link: "bus-booking-for-marriage-in-pune" },
    { place: "/images/keyword/21.jpg", text: "Bus Service for Corporate in Pune", link: "bus-service-for-corporate-in-pune" },
    { place: "/images/keyword/22.jpg", text: "Bus on Rent For Event in Pune", link: "bus-on-rent-for-event-in-pune" },
    { place: "/images/keyword/23.jpg", text: "Bus Hire for Outstation in Pune", link: "bus-hire-for-outstation-in-pune" },
    { place: "/images/keyword/24.jpg", text: "AC Bus On Rent in Pune", link: "ac-bus-on-rent-in-pune" },
    { place: "/images/keyword/25.jpg", text: "Pune Bus Hire Rental Service", link: "pune-bus-hire-rental-service" },
  ];









const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Bus Hire in Yavat Pune - Sanavi Travels",
  "description": "Sanavi Travels provides bus hire in Yavat Pune for weddings, corporate travel, picnics, and outstation trips. We offer AC and Non-AC buses, luxury buses, mini buses, 32 seater and 35 seater buses with professional drivers at affordable rates.",
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.7",
    "ratingCount": "10000+"
  }
};







  return (
    <div>

<Helmet>
  <title>
    Call : +91 7387507373 | Bus Hire in Yavat Pune | Sanavi Travels
  </title>

  <meta
    name="description"
    content="Book bus hire in Yavat Pune with Sanavi Travels. AC & Non-AC buses, luxury and mini bus rental for weddings, corporate travel, picnics, and outstation trips with driver at best prices."
  />

  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>

      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box text-white">
                <h1 className="text-anime-style-3 text-center text-white" data-cursor="-opaque">
                  <h3> {cardData.keyword}</h3>
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>





      <section>
        <div className="container-fluid" >
          <div className="row container-fluid p-0">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/223.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>



              <div className="shambhu-services">
                {cardData.services.map((service, index) => (
                  <div key={index} className="sh-service-card">

                    <div className="sh-service-left">
                      <div className="sh-service-icon">
                        🚖
                      </div>
                    </div>

                    <div className="sh-service-content">
                      <h4 className="sh-service-title">{service.name}</h4>
                      <p className="sh-service-desc">{service.description}</p>
                    </div>

                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Sanavi Travels </span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sanavi Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+917387507373" className="pc-call">+91 7387507373</a>
                      <a href="tel:+919595532929" className="pc-call">+91 9595532929</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/917387507373"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+917387507373" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@sanavitravels.com" className="pc-email">
                      booking@sanavitravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Sanavi Travels</strong><br />
                      OFFICE NO.6, GROUND FLOOR GAT NO.1110,
                      SHREE GOPINATH MAHARAJ VYAPARI SHED SHIVAJI CHOWK, VARVAND TAL DAUND,
                      DIST PUNE – 412215
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Bushireinyavatpune;